import src from "IMAGE";
export default { src, width: 1330, height: 1070, blurWidth: 0, blurHeight: 0};
